import React from 'react';
import { useSelector } from 'react-redux';
import { default as ReactTimeAgo } from 'react-timeago';
import { reactTimeAgoFormatter } from '@rsos/utils/timeHelpers';
import { findData } from './EllingtonCard';
import selectADRForCall from './selectADRForCall';

export const TimeAgo = ({ timestamp, minPeriod = 15 }) => {
  return (
    <>
      {timestamp && (
        <ReactTimeAgo
          data-name="ellington-card-time-ago"
          formatter={reactTimeAgoFormatter}
          date={timestamp}
          minPeriod={minPeriod}
        />
      )}
    </>
  );
};

const ConnectedTimeAgo = ({ dataPath = '', selectedCallerID = '' }) => {
  const dataPathArray = dataPath.split('.');
  const timestamp = useSelector(state => {
    const additionalData = selectADRForCall(state, selectedCallerID);
    if (!additionalData) {
      return <></>;
    }
    const found = findData(additionalData, dataPathArray);
    return found?.createdTime;
  });
  return <TimeAgo timestamp={timestamp} />;
};

export default ConnectedTimeAgo;
